import Rollbar from 'rollbar';
import { CODE_VERSION } from 'src/environments/code-version';

export default {
  rollbar: {
    accessToken: 'a89aac7923704d79b5b1cebfe98e0c22',
    captureUncaught: true,
    captureUnhandledRejections: true,
    addErrorContext: true,
    client: {
      javascript: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        code_version: CODE_VERSION
      }
    }
  } as Rollbar.Configuration,
  userSession: {
    closeSessionOnEveryPageReload: false,
    inactivityTimeout: { // Inactivity timeout (minutes)
      default: 5,
      onboarding: 240
    }
  },
  externalLogin: {
    port: null
  },
  analytics: {
    tealium: {
      enabled: false
    },
    customerIoSiteId: null,
    gtmId: null
  },
  appStore: {
    appPageLink: {
      android: 'https://play.google.com/store/apps/details?id=com.finizens.app',
      ios: 'https://apps.apple.com/es/app/finizens/id1243555874'
    }
  }
};
